import {  IsNotEmpty, IsAlphanumeric, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class TypesRequest {
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    typeId: number;

    @ApiProperty()
    @IsOptional()
    updatedUser: string;

    @ApiProperty()
    @IsOptional()
    @IsNumber()
    versionFlag: number;

    @ApiProperty()
    isActive: boolean;
}